import React from 'react';
import { connect } from 'react-redux';
import * as actions from "../redux/user";
import AuthenticateChildren from '../AuthenticateChildren';
import { roles } from '../constants';
import './AsClient.css';
import { FeatherButton } from './FeatherButton';
import { X } from 'react-feather';
import { history } from '../configureStore';
import AuthService from '../AuthService';

const AsClient = (props) => {
    const bob = () => {
        AuthService.getInstance().removeAsClient();
        history.go();
    };

    return props.asClientName ? <AuthenticateChildren roles={[roles.Admin]} ignoreViewAs={true}>
        <div className="as-client">
            Browsing as: <span>{props.asClientName}</span> <FeatherButton feather={<X />} onClick={() => bob()} />
        </div>
    </AuthenticateChildren> : null;
};

const mapStateToProps = ({ user }) => ({
    asClientId: user.asClientId,
    asClientName: user.asClientName
});

export default connect(mapStateToProps, actions)(AsClient);


// WEBPACK FOOTER //
// ./src/components/AsClient.js